<template>
  <div class="card-footer">
    <div class="footer-links ml-2">
      <button @click.prevent.stop="showForm()" type="button" class="btn btn-secondary">wypłata</button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    showForm() {
      this.$store.commit("setDisplayFormFastPayment", false);
      this.$store.commit("setDisplayFormPayout", true);
      this.$store.commit("setDisplayFormAccounts", false);
    }
  }
};
</script>